import styled from 'styled-components'

export const S_Grid = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: ${(props) => props.alignItems};
  justify-content: ${(props) => props.justifyContent};
  margin: ${(props) => `0px -${props.gutters}px`};
`
